'use client';

import { c as _c } from "react/compiler-runtime";
import { MonitorSmartphoneIcon } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { Button } from '@/components/ui/button';
import { Card, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
interface MobileUnsupportedProps {
  onSwitchToLetter: () => void;
}
export function MobileUnsupported(t0) {
  const $ = _c(20);
  const {
    onSwitchToLetter
  } = t0;
  const t = useTranslations("playground_page.mobile_unsupported");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <MonitorSmartphoneIcon className="size-5" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== t) {
    t2 = t("title");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <CardTitle className="flex items-center gap-2 font-semibold text-foreground text-xl">{t1}{t2}</CardTitle>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t("description");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <CardDescription>{t4}</CardDescription>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t5) {
    t6 = <CardHeader>{t3}{t5}</CardHeader>;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t) {
    t7 = t("switch_to_letter");
    $[12] = t;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== onSwitchToLetter || $[15] !== t7) {
    t8 = <CardFooter className="flex items-center justify-end"><Button onClick={onSwitchToLetter}>{t7}</Button></CardFooter>;
    $[14] = onSwitchToLetter;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t6 || $[18] !== t8) {
    t9 = <div className="absolute inset-0 z-4 flex items-center justify-center bg-background/95 p-3 backdrop-blur-sm"><Card className="mt-8! w-full! rounded-lg">{t6}{t8}</Card></div>;
    $[17] = t6;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
}